var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 15.3333H0.666992V8.66663H3.33366",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8.66663L6.00065 0.666626H6.66732C7.19775 0.666626 7.70646 0.87734 8.08153 1.25241C8.4566 1.62749 8.66732 2.13619 8.66732 2.66663V5.99996H13.0273C13.3139 5.99995 13.597 6.06151 13.8577 6.18047C14.1184 6.29943 14.3505 6.47301 14.5382 6.68946C14.726 6.90591 14.865 7.16018 14.946 7.43505C15.0269 7.70992 15.0478 7.99897 15.0073 8.28263L14.246 13.616C14.178 14.0924 13.9405 14.5283 13.577 14.8437C13.2136 15.1592 12.7486 15.333 12.2673 15.3333H3.33398V8.66663Z",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLike);
export default __webpack_public_path__ + "static/media/orange_like.91271991a916b8b2d5a71a0d8f820056.svg";
export { ForwardRef as ReactComponent };